import { SelectBoxOpt } from '@/components/content/SelectBox'

export const SCHEDULE_SHIPPER_EMPTY_MESSAGE = '조회 가능한 화주가 없습니다.'

/**
 * 출고일정관리(1.0 · 2.5) 화주 선택지·선택값 결정 (LOGISPRD-12495)
 *
 * 출고일정 API 는 로그인 사용자의 허용 화주만 받는다 — 허용 밖 화주는 조회가 빈 그리드, 저장이 403 이다.
 * - 선택지 = 고정 선택지 ∩ 허용 화주. 출고일정은 고정 선택지 화주만 대상이라 순서도 고정 선택지를 따른다
 * - 선택값 = 요청 화주가 선택지에 있으면 그 값, 없으면 선택지 첫 값. 선택지가 비면 undefined
 * - 허용 화주를 모르면(조회 실패) 고정 선택지를 그대로 쓴다 — 판정 원천은 서버다
 */
export const resolveScheduleShipper = <T extends string>({
  options,
  requested,
  allowedShipperCodes,
}: {
  options: SelectBoxOpt<T>[]
  requested?: string
  allowedShipperCodes?: readonly string[]
}): { options: SelectBoxOpt<T>[]; shipperCode: T | undefined } => {
  const allowedOptions = allowedShipperCodes ? options.filter(({ value }) => allowedShipperCodes.includes(value)) : options
  const shipperCode = allowedOptions.find(({ value }) => value === requested)?.value ?? allowedOptions[0]?.value

  return { options: allowedOptions, shipperCode }
}
